export const blockIconsAudioandvideoVolumeMuteNew = (
	<span className='material-symbols-outlined'>volume_mute</span>
);
